export default defineNuxtPlugin(nuxtApp => {
	nuxtApp.hook('page:finish', () => {
		const route = useRoute()
		if (route.hash) {
			setTimeout(() => {
				const element = document.querySelector(route.hash)
				if (element) {
					const offset = 50
					// const { height } = element.getBoundingClientRect()
					// const offsetPosition = height + window.pageYOffset
					element.scrollIntoView({ behavior: 'smooth', block: 'start' })
					window.scrollTo({
						top: -offset,
						behavior: 'smooth'
					})
				}
			}, 100) // Small delay to ensure the page is fully rendered
		}
	})
})
